/**
 * Parses an Axios error response and returns a human-readable error message.
 * @param {Error} error - The caught error object
 * @param {string} defaultMessage - Fallback message when no details are available
 * @returns {string} A human-readable error message
 */
export const parseErrorMessage = (error, defaultMessage = 'An error occurred') => {
    // A timed-out axios request rejects with a code and no `response` (issue #407);
    // name it explicitly instead of falling through to the generic default.
    if (error && (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT')) {
        return 'The server took too long to respond. Please try again.'
    }
    if (error.response && error.response.data) {
        const data = error.response.data
        const { detail } = data
        if (detail && Array.isArray(detail)) {
            return detail.join(', ')
        } else if (detail && typeof detail === 'object') {
            return Object.values(detail).flat().join(', ')
        } else if (detail) {
            return detail
        } else if (data.message) {
            return data.message
        } else if (typeof data === 'object' && !Array.isArray(data)) {
            // Field-level validation errors: { field: ['error message', ...], ... }
            const fieldErrors = Object.values(data).flat()
            if (fieldErrors.length > 0) return fieldErrors.join(', ')
        }
    }
    return defaultMessage
}
